import type { RoutingGuideEnumsType } from "~/shared/schemas/routing-guide-schema";

export const getLabelsForSelector = (
	selectorName: string,
	enums: RoutingGuideEnumsType | undefined,
): string[] => {
	const addressLabels = enums?.addressFields.map((f) => f.label) ?? [];
	const hoursLabels = enums?.hoursFields.map((f) => f.label) ?? [];
	const nmfcLabels = enums?.nmfcFields.map((f) => f.label) ?? ["Code"];
	const commodityLabels = enums?.commodityDescriptionFields.map(
		(f) => f.label,
	) ?? ["Commodity Description"];
	const map: Record<string, string[]> = {
		Origin: addressLabels,
		Destination: addressLabels,
		OriginHours: hoursLabels,
		DestinationHours: hoursLabels,
		NMFC: nmfcLabels,
		CommodityDescription: commodityLabels,
		CarrierName: ["Carrier Name"],
		ServiceLevels: ["Service Levels"],
		TransitTime: ["Transit Time"],
	};
	return map[selectorName] ?? [];
};
